(() => {
  const digitalGiftHandles = new Set([
    'nfl-training-systems-6-week-program-vol-1',
    'braintree-cognitive-edge-diet',
  ]);
  let pending;
  let rerun = false;

  async function reconcile() {
    if (pending) {
      rerun = true;
      return pending;
    }
    pending = (async () => {
      do {
        rerun = false;
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        if (!response.ok) throw new Error('Unable to check subscription gifts');
        const cart = await response.json();
        const subscriptions = cart.items.filter((item) => item.selling_plan_allocation);
        const updates = {};
        for (const item of cart.items) {
          const parent = item.properties?._subscription_gift_parent;
          const isDigitalGift = digitalGiftHandles.has(item.handle);
          if (!parent && !isDigitalGift) continue;
          const minQuantity = Number(item.properties?._subscription_gift_min_qty) || 0;
          const eligible = subscriptions.some((subscription) =>
            parent
              ? String(subscription.variant_id) === String(parent) && (!minQuantity || subscription.quantity >= minQuantity)
              : subscription.handle === 'focus-hydration'
          );
          if (!eligible) updates[item.key] = 0;
        }
        if (!Object.keys(updates).length) continue;
        const result = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });
        if (!result.ok) throw new Error('Unable to remove ineligible subscription gifts');
        const cartData = await result.json();
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'subscription-gifts', cartData });
        window.Rebuy?.Cart?.fetchCart();
      } while (rerun);
    })().finally(() => { pending = null; });
    return pending;
  }

  const check = () => reconcile().catch(console.error);
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source !== 'subscription-gifts') return check();
  });
  document.addEventListener('rebuy:cart.change', check);
  window.addEventListener('pageshow', check);

  // Check again before ordinary cart and Rebuy checkout controls navigate away.
  async function guardCheckout(event) {
    const control = event.type === 'submit'
      ? event.submitter
      : event.target.closest?.('a[href*="/checkout"], button[name="checkout"], .rebuy-cart__checkout-button');
    if (!control || (event.type === 'submit' && control.name !== 'checkout')) return;
    if (control.dataset.giftsVerified === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      await reconcile();
      control.dataset.giftsVerified = 'true';
      if (event.type === 'submit') event.target.requestSubmit(control);
      else control.click();
      delete control.dataset.giftsVerified;
    } catch (error) {
      console.error(error);
      window.alert('We could not verify your subscription gifts. Please try checkout again.');
    }
  }
  document.addEventListener('click', guardCheckout, true);
  document.addEventListener('submit', guardCheckout, true);
})();
